
'use client'

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FolderGrid from "../components/common/FolderCard";
import PocketBase from "pocketbase";
import { Loader2 } from "lucide-react";
import { Typography } from "@mui/material";
import Slider from "react-slick";

const pb = new PocketBase(process.env.REACT_APP_POCKETBASE_URL);

const OLFolderPage = () => {
  const [folders, setFolders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [slides, setSlides] = useState([]);
  const [, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFolders = async () => {
      try {
        const records = await pb.collection("OLFolders").getFullList();
        setFolders(records);
      } catch (error) {
        console.error("Error fetching folders:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchSlides = async () => {
      try {
        const records = await pb.collection("OL_Slides").getFullList();
        setSlides(records);
      } catch (error) {
        console.error("Error fetching mobile slides:", error);
      }
    };

    fetchSlides();
    fetchFolders();
  }, []);

  const handleSelect = (folder) => {
    setSelectedFolder(folder.id);
    navigate(`/ol/${encodeURIComponent(folder.id)}`);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <Loader2 className="animate-spin text-red-500" size={48} />
        <span className="ml-4 text-xl font-medium text-gray-700">Loading...</span>
      </div>
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (current, next) => setCurrentSlide(next),
  };

  return (
    <div className="flex flex-col gap-8 p-6 bg-gray-100 min-h-screen">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
        <Typography variant="h3" className="col-span-full" sx={{ 
          mb: 4,
          textAlign: "center",
          fontWeight: 700,
          color: "text.primary",
          letterSpacing: "-0.05rem",
          marginTop: "20px",
          "&:after": {
              content: '""',
              display: "block",
              width: "60px",
              height: "4px",
              backgroundColor: "primary.main",
              margin: "8px auto 0",
          }
        }}>
          O/L Api
        </Typography>

        <div className="col-span-full flex justify-center h-32 overflow-hidden">
        <div className="w-full max-w-2xl justify-center">
        <Slider {...settings}>
          {slides.map((slide, idx) => (
            <div key={slide.id || idx} className="flex flex-col items-center justify-center">
              {slide.image ? (
                <img
                  src={`${process.env.REACT_APP_POCKETBASE_URL}/api/files/${slide.collectionId}/${slide.id}/${slide.image}`}
                  alt={slide.title || `Slide ${idx + 1}`}
                  className="shadow-md  object-contain"
                  style={{ width: "100%", maxHeight: "300px" }}
                />
              ) : (
                <div className="w-full h-48 flex items-center justify-center bg-gray-200 rounded-lg">
                  <span className="text-gray-500 text-lg">No Image</span>
                </div>
              )}
            </div>
          ))}
        </Slider>
      </div>
      </div>
        {folders.map((folder) => (
          <FolderGrid
            key={folder.id}
            card={folder}
            isSelected={folder.id === selectedFolder}
            onSelect={() => handleSelect(folder)}
          />
        ))}
      </div>      
    </div>
  );
};

export default OLFolderPage;
